(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shamos-email-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shamos-email-signup')) {
  customElements.define('shamos-email-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-signup-open]');
      const form = this.querySelector('form');
      let result = this.querySelector('[data-signup-result]');
      const confirmed = this.querySelector('[data-signup-confirmed]');
      const unconfirmed = this.querySelector('[data-signup-unconfirmed]');
      const key = 'shamos-email-signup-return';
      const current = new URL(location.href);
      let pending = null;
      try {
        pending = JSON.parse(sessionStorage.getItem(key));
        if (!pending || pending.id !== form.id || pending.path !== current.pathname || Date.now() - pending.time > 1800000) pending = null;
      } catch (_) {}
      if (pending && pending.status === 'success') {
        if (result) result.hidden = true;
        confirmed.hidden = false;
        result = confirmed;
        form.querySelectorAll('label, input[type="email"], button[type="submit"]').forEach((element) => { element.hidden = true; });
      }
      const returned = current.searchParams.get('shamos_signup') === form.id || current.hash === '#' + trigger.id || current.hash === '#' + form.id;
      const submittedHere = returned || Boolean(result && pending);
      const returnURL = () => {
        const source = new URL(location.href);
        const target = new URL(source.pathname, source.origin);
        ['variant', 'preview_theme_id', '_fd', 'pb'].forEach((name) => {
          if (source.searchParams.has(name)) target.searchParams.set(name, source.searchParams.get(name));
        });
        if (!target.searchParams.has('preview_theme_id') && this.dataset.previewThemeId) target.searchParams.set('preview_theme_id', this.dataset.previewThemeId);
        target.searchParams.set('shamos_signup', form.id);
        target.hash = trigger.id;
        return target.pathname + target.search + target.hash;
      };
      const focusTarget = () => result || (!unconfirmed.hidden ? unconfirmed : form.querySelector('input[type=email]')) || this.querySelector('[data-signup-close]');
      const open = () => {
        if (!dialog.open) dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        focusTarget().focus({ preventScroll: true });
      };
      trigger.addEventListener('click', open);
      this.querySelector('[data-signup-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({ preventScroll: true });
      });
      form.addEventListener('submit', () => {
          try {
          sessionStorage.setItem(key, JSON.stringify({ id: form.id, time: Date.now(), path: location.pathname, returnTo: returnURL(), x: window.scrollX, y: window.scrollY }));
        } catch (_) {}
      }, true);
      if (submittedHere) {
        const suppressCompetingAutofocus = () => {
          document.querySelectorAll('[id^="Newsletter__Success--"][autofocus]').forEach((element) => element.removeAttribute('autofocus'));
        };
        suppressCompetingAutofocus();
        unconfirmed.hidden = Boolean(result);
        const restore = () => {
          if (!dialog.open) return;
          if (pending && Number.isFinite(pending.y)) window.scrollTo({ left: pending.x || 0, top: pending.y, behavior: 'instant' });
          else trigger.scrollIntoView({ block: 'center', behavior: 'instant' });
          focusTarget().focus({ preventScroll: true });
        };
        const showResult = () => {
          suppressCompetingAutofocus();
          open();
          restore();
          requestAnimationFrame(restore);
          if (document.readyState !== 'complete') window.addEventListener('load', restore, { once: true });
          try { sessionStorage.removeItem(key); } catch (_) {}
          const clean = new URL(location.href);
          clean.searchParams.delete('shamos_signup');
          if (clean.hash === '#' + trigger.id || clean.hash === '#' + form.id) clean.hash = '';
          history.replaceState(history.state, '', clean.pathname + clean.search + clean.hash);
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showResult, { once: true });
        else showResult();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
